import React from 'react';
import { Text, StyleProp, TextStyle } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import Utilities from '../~Utilities/Utilities';

interface IOBLastPrice
{
IsCurrent : ()=>boolean;
style?: StyleProp<TextStyle>;
getText: () => string;
index:number;
bindEvent : (onEvent    : (() => void), 
             bSubscribe : boolean) => void;
setCenter : (center : number) => void;

goCenter : () => void;
//bAvgOpen : boolean;
}

/*   ---------------------------------------------------------------------   */

export default class OBLastPrice extends React.Component<IOBLastPrice>
   {
   UpdateData()
   {
   var bIsCurrent = this.props.IsCurrent();
   var sNewText   = this.props.getText();
   
   //if (bIsCurrent == true)
     // Utilities.Sendlog("current: " + sNewText);

   if (this.state.bIsCurrent != bIsCurrent ||
       this.state.sText      != sNewText)
      {
      if (bIsCurrent == true)
         this.props.setCenter(this.props.index);

      this.setState({bIsCurrent: bIsCurrent,
                     sText: sNewText});
      }
   }

   /*   ------------------------------------------------------------------   */
   
   constructor(props)
   {
   super(props);
   this.state      = {bIsCurrent: this.props.IsCurrent(),
                      sText:this.props.getText(),
                      is_avg_fillprice: false}

   if (this.state.bIsCurrent == true)
      this.props.setCenter(this.props.index);

   this.UpdateData          = this.UpdateData.bind(this);
   this.SetAvgOpenFillPrice = this.SetAvgOpenFillPrice.bind(this);
   }

   /*   ------------------------------------------------------------------   */

   public SetAvgOpenFillPrice(bValue : boolean)
   {
   if (this.state.is_avg_fillprice != bValue) 
      {
      this.setState({is_avg_fillprice:bValue});
      }
   }

   /*   ------------------------------------------------------------------   */

   componentDidMount() 
   {
   this.props.bindEvent(this.UpdateData, true);
   }

   /*   ------------------------------------------------------------------   */

   componentWillUnmount() 
   {
   this.props.bindEvent(this.UpdateData, false);
   }

   /*   ------------------------------------------------------------------   */
   
   state = {bIsCurrent: false, sText:"", is_avg_fillprice:false}

   /*   ------------------------------------------------------------------   */

   render() 
     {
      if (this.state.bIsCurrent && this.state.is_avg_fillprice)
         return(
         <LinearGradient
         colors={['tomato', '#0247fe', 'tomato']}
         start={{x: 0, y: 0}} end={{x: 1, y: 0}}
          >
         <Text style={[this.props.style, {backgroundColor:'transparent', color:'white'}]}
          onPress={(event)=>{Utilities.Sendlog("Centering on last click..."); this.props.goCenter()}}
         > {this.state.sText} </Text>
         </LinearGradient>
         );
      else return (
      //  <View style={this.state.bIsCurrent? {backgroundColor:'tomato', borderRadius:0, } : {backgroundColor:'transparent', }}>
       <Text style={this.state.bIsCurrent? [this.props.style, {backgroundColor:'tomato', color:'white', }] : 
                    this.state.is_avg_fillprice? [this.props.style, {backgroundColor:'#0247fe', color:'white'}] :
                                                 [this.props.style, {backgroundColor:'transparent', color:'slategrey'}]
                    }
         onPress={(event)=>{Utilities.Sendlog("Centering on last click..."); this.props.goCenter()}}
         > {this.state.sText} </Text>
      //  </View>
      );
   }
}